import React from "react"
import { Chart } from "react-google-charts"
import { Box, Typography, CircularProgress, CardContent, Card } from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { RectSvg } from "../../icons"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	legends: {
		height: "100%",
		float: "right",
		display: "flex",
		"& div": {
			display: "flex",
			alignItems: "center",
			padding: "5px",
		},
	},
	svgLegend: {
		"& p": {
			fontSize: theme.typography.caption.fontSize,
		},
	},
	label: {
		paddingLeft: "8px",
	},
	loading: { width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" },
	card: {
		height: "460px",
		width: "100%",
	},
	cardContent: {
		padding: "24px",
	},
	title: {
		color: theme.palette.grey.D300,
		fontWeight: theme.typography.subTitle1.fontWeight,
	},
}))

const JobSummary = (props) => {
	const [t] = useTranslation("global")
	const theme = useTheme()
	const classes = useStyles()
	const { data, loading, title, legends = [], barWidth, axisTitle } = props
	const groupWidth = barWidth || `${(50 * data.length) / 20}%`
	const options = {
		bar: { groupWidth: groupWidth },
		legend: { position: "none" },
		axisTitlesPosition: "out",
		annotations: {
			textStyle: {
				fontSize: 15,
				bold: true,
				color: theme.palette.common.black,
			},
		},
		tooltip: {
			textStyle: {
				fontSize: 12,
				width: "100%",
			},
		},
		hAxis: {
			title: axisTitle.x,
			minValue: 0,
		},
		vAxis: {
			title: axisTitle.y,
		},
	}
	const getLegends = () => {
		return (
			<div className={classes.legends}>
				{legends.map((legend) => {
					return (
						<div className={classes.svgLegend}>
							<RectSvg color={legend.color} />
							<Typography variant="body2" component="p" className={classes.label}>
								{legend.text}
							</Typography>
						</div>
					)
				})}
			</div>
		)
	}
	return (
		<Card className={classes.card}>
			<CardContent className={classes.cardContent}>
				<Typography variant="subtitle1" className={classes.title}>
					{title}
				</Typography>
				{data.length > 1 ? (
					<>
						<Chart chartType="ColumnChart" height="360px" data={data} options={options} />
						{!!legends.length && getLegends()}
					</>
				) : (
					<div className={classes.loading}>
						{loading ? (
							<CircularProgress />
						) : (
							<Typography variant="subtitle2" component="p" className={classes.label}>
								{t("bifrost.charts.noSummaryMessage")}
							</Typography>
						)}
					</div>
				)}
			</CardContent>
		</Card>
	)
}

export default JobSummary
